export default __webpack_public_path__ + "static/spiral-1-f7b567dfeb82bffd0d7e0dd82d8b2b73.png";